import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropertyForm from '../../components/Properties/PropertyForm'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'

function PropertyCreate() {
    const navigate = useNavigate()
    // handleGoBack
    const handleGoBack = () => {
        navigate('/properties-list')
    }

    // create action
    const handleForm = async (data) => {
        try {
            let formData = {
                ownershipgroups_id: data?.ownershipgroups_id,
                regions_id: data?.regions_id,
                region_name: data?.region_name,
                property_name: data?.property_name,
                property_description: data?.propertyDescription,
                property_city: data?.property_city,
                property_state: data?.propertyState,
                local_utc_offset: data?.local_utc_offset,
                status_val: data?.status_val,
            }
            const response = await nbrApi.post('/createproperty', formData)
            const responseData = response.data
            if (responseData) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `Property Record Created Successful`,
                    showConfirmButton: false,
                    timer: 2000,
                }).then(() => {
                    handleGoBack()
                })
            }
        } catch (error) {
            console.error('Error fetching data:', error.message)
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Property Record Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }
    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create new Property</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <PropertyForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PropertyCreate